<template>

	<div class="dropdown-item">
		<div class="dropdown-intro" >
			<DrowdownLine :is-expanded="isExpanded" :cb="toggleExpanded">
				<b>{{ item.title }}</b>
			</DrowdownLine>
			<div class="dropdown-teaser"> {{ item.teaser }}</div>
			<Collapse :when="isExpanded">
				<div class="dropdown-expanded-text" v-html="item.text"></div>
			</Collapse>
		</div>
	</div>
</template>

<script setup>
  import { defineProps, reactive, ref, watch } from "vue";
  import { Collapse } from 'vue-collapsed';
	import { useStore } from 'vuex';

	const store = useStore()

	import DrowdownLine from './dropdown-line.vue';

	watch(() => store.getters.selectedCompanyName, function() {
    isExpanded.value = false;
   });

  const props = defineProps({
    item: Object
  });

const isExpanded = ref(false)

const toggleExpanded = () => {
	isExpanded.value = !isExpanded.value;
}
</script>

<style lang="scss">
	.dropdown-item {
		background: var(--lightblue);
		padding: 2rem;
		display: flex;

		a, a:visited, a:hover {
			color: var(--moss) !important;
		}

		.dropdown-header {
			display: flex;
			align-items: center;
			margin-bottom: 1rem;

			svg {
				margin-right: 10px;
			}
		}
		.dropdown-expanded-text {
				margin-top: 2rem;
			}
			
			.uitklap-icon {
				width: 30px;
				height: auto;
				transform-origin: 50% 50%;
				transition: transform .2s;
				transform: rotate(-45deg);

				path {
					fill: var(--moss);
				}
				&.is-expanded {
					transform: rotate(0deg);
				}
			}

	}

</style>